import * as React from 'react';

export default class CollapsibleContentIntro extends React.PureComponent<{}, {}> {
    render() {
        return <div className="collapsible-content-intro">{this.props.children}</div>;
    }
}
